import styled from 'styled-components';

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  width: auto;

   @media (max-width: 768px) {
    width: 100%;
  }
`;

export const DropdownButton = styled.button`
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
  margin-right:10px;

  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0;
  }

  &:after {
    content: '';
    display: inline-block;
    margin-left: 10px;
    width: 8px;
    height: 8px;
    border-right: 2px solid #333;
    border-bottom: 2px solid #333;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(-135deg)' : 'rotate(45deg)')};
    transition: transform 0.3s ease;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 8px;
  padding: 8px 0;
  z-index: 1000;
  width: 160px;
  max-height: 150px;
  overflow-y: auto;

  div {
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;
    color: #333;

    &:hover {
      background-color: rgba(97, 203, 201, 0.5);
      border-radius: 4px;
    }
  }
`;
